import http from "@/utils/http.js"

export default{
    async page(params){
        let api = "/memberAccountLog/page";
        let result = await http.get(api,params);
        return result.success && result.data;
    },
}